import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../../css/NotificationCenter.css'
import { ApiClient } from "../../libs/apiClient";
import config from '../../config';
import socketService from '../../libs/sockets/SocketService';
const apiClient = ApiClient.getInstance();
class NotificationCenter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            currentUser: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')) || '',
            notifications: [],
            countVieweds: 0,
            expandedMessages: {},
        };
        this.notificationRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount = async () => {
        socketService.setNotificationCenterRef(this);
        await this.getNotifications();
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    getNotifications = async () => {
        const { currentUser } = this.state;
        let notifications = [];
        let countVieweds = 0;

        if (currentUser !== '') {
            const response = await apiClient.getNotifications(currentUser.USERID || 'id');
            if (response.status === 1) {
                notifications = response.data.notifications;
                countVieweds = response.data.countVieweds;
                this.setState({ notifications, countVieweds });
            }
        }
    }

    handleClickOutside = (event) => {
        if (this.notificationRef && this.notificationRef.current && !this.notificationRef.current.contains(event.target)) {
            this.setState({ isOpen: false });
        }
    };

    toggleNotifications = () => {
        this.viewNotifications();
        this.setState(prevState => ({
            isOpen: !prevState.isOpen
        }));
    };

    viewNotifications = async () => {
        const { notifications, countVieweds } = this.state;
        const notiViewedIds = [];
        const copyNotifications = [...notifications];

        if (countVieweds > 0) {
            copyNotifications.forEach(notification => {
                if (notification.seen === 0 || notification.seen === false) {
                    notification.seen = 1;
                    notiViewedIds.push({ id: notification.id });
                }
            });

            this.setState({ countVieweds: 0, notifications: copyNotifications });

            await apiClient.viewedNotifications(notiViewedIds);
        }
    }

    toggleExpandMessage = (id) => {
        this.setState((prevState) => ({
            expandedMessages: {
                ...prevState.expandedMessages,
                [id]: !prevState.expandedMessages[id]
            }
        }));
    };

    processText = (text, condition = false) => {
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        const parts = text.split(urlRegex);

        if (condition && text.length > 50) {
            text = text.substring(0, 50);
        }

        return text.split(urlRegex).map((part, index) => {
            if (part.match(urlRegex)) {
                return <a key={index} href={parts[index]} target="_blank" rel="noopener noreferrer" style={{ color: '#337AFF' }}>{part}</a>;
            }
            return part;
        });
    };

    render() {
        const { isOpen, notifications, countVieweds, expandedMessages } = this.state;
        return (
            <div className="notification-center" ref={this.notificationRef}>
                <button className="notification-center-icon iconNotification" onClick={this.toggleNotifications}>
                    <i className="fa fa-bell"></i>
                    {countVieweds > 0 &&
                        <span className="notification-center-count">{countVieweds}</span>
                    }
                </button>
                {isOpen && (
                    <div className="notification-center-dropdown">
                        <div className="notification-center-header">
                            <h5>Notificaciones</h5>
                            <button className="close-btn" onClick={() => this.setState({ isOpen: false })}>
                                <i className="fa fa-times"></i>
                            </button>
                        </div>
                        <div className="notification-center-list">
                            {notifications.length === 0 ? (
                                <ul>
                                    <li>
                                        <i className={'fa fa-info-circle'} style={{ color: 'blue', fontSize: '24px', marginRight: '10px' }}></i>
                                        <div className="notification-center-content">
                                            <p className="notification-center-title">No tienes ninguna notificación</p>
                                        </div>
                                    </li>
                                </ul>
                            ) : (
                                <ul>
                                    {notifications.map(notification => (
                                        <li key={notification.id}>
                                            <i className={`fa ${notification.icon.name}`} style={{ color: notification.icon.color, fontSize: '24px', marginRight: '10px' }}></i>
                                            <div className="notification-center-content">
                                                <p className="notification-center-title">{notification.title}</p>
                                                <p className="notification-center-message">
                                                    {notification.message.length > 50 && !expandedMessages[notification.id] ? (
                                                        <>
                                                            {this.processText(notification.message, true)}...
                                                            <span style={{ color: '#00AEEF', display: 'block', cursor: 'pointer', fontSize: 'small', fontWeight: 'bold' }} onClick={() => this.toggleExpandMessage(notification.id)}>
                                                                Ver más
                                                                <i className="fa fa-chevron-down" style={{ marginLeft: '5px' }} />
                                                            </span>
                                                        </>
                                                    ) : (
                                                        <>
                                                            {this.processText(notification.message)}
                                                            {notification.message.length > 50 && (
                                                                <span style={{ color: '#00AEEF', display: 'block', cursor: 'pointer', fontSize: 'small', fontWeight: 'bold' }} onClick={() => this.toggleExpandMessage(notification.id)}>
                                                                    Ver menos
                                                                    <i className="fa fa-chevron-up ms-3" style={{ marginLeft: '5px' }} />
                                                                </span>
                                                            )}
                                                        </>
                                                    )
                                                    }
                                                </p>
                                                <small className="notification-center-time">{notification.time_elapsed}</small>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                        <div className="notification-center-triangle"></div>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        notificationReducer: store.NotificationReducer
    };
};

export default connect(
    mapStateToProps,
)(NotificationCenter);